import { makeService } from './api';

const service = makeService('attendance_list_templates');

export default service;
